import {
  ORGANISATION_PREFERENCES_GET,
  ORGANISATION_PREFERENCES_GET_FAIL,
  ORGANISATION_PREFERENCES_GET_SUCCESS,
  ORGANISATION_PREFERENCES_UPDATE,
  ORGANISATION_PREFERENCES_UPDATE_FAIL,
  ORGANISATION_PREFERENCES_UPDATE_SUCCESS
} from '../actions/organisationPreferencesActions'

const initialState = {
  data: null,
  error: null,
  loading: false,
  updating: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ORGANISATION_PREFERENCES_GET:
      return { ...state, loading: true, error: null }
    case ORGANISATION_PREFERENCES_GET_SUCCESS:
      return { ...state, data: action.payload.data, loading: false, error: null }
    case ORGANISATION_PREFERENCES_GET_FAIL:
      return { ...state, loading: false, error: action.error }
    case ORGANISATION_PREFERENCES_UPDATE:
      return { ...state, updating: true, error: null }
    case ORGANISATION_PREFERENCES_UPDATE_SUCCESS: {
      if (!action.payload.data.success) {
        return { ...state, updating: false, error: action.payload.data.errors }
      }

      const submittedPreferences = action.meta && action.meta.previousAction &&
        action.meta.previousAction.payload && action.meta.previousAction.payload.request &&
        action.meta.previousAction.payload.request.data
        ? action.meta.previousAction.payload.request.data.request
        : null

      return {
        ...state,
        data: state.data
          ? { ...state.data, ...submittedPreferences, needsOrganisationPreferences: false }
          : state.data,
        updating: false,
        error: null
      }
    }
    case ORGANISATION_PREFERENCES_UPDATE_FAIL:
      return { ...state, updating: false, error: action.error }
    default:
      return state
  }
}
